import { hookstate, useHookstate } from '@hookstate/core';

export const helpState = hookstate({ show: false, help: null });

const wrapState = (s) => ({
    get: () => s.value,
    set: (_value) => { s.set(_value) },
    hideHelp: () => { s.set({ ...s.value, show: false }); },
    showHelp: () => {
        if (s.value.show || (s.value.help && !localStorage.getItem(s.value.help))) {
            localStorage.setItem(s.value.help, true);
            return true;
        };
        return false;
    },
})

export const useGlobalHelpState = () => wrapState(useHookstate(helpState));

